<script>
export default {
  name: 'SignatureDocuments',
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    iconClass(name) {
      const ext = name.split('.').pop().toLowerCase()
      if (ext === 'pdf') return 'bi-file-pdf'
      if (ext === 'doc' || ext === 'docx') return 'bi-file-word'
      return 'bi-file-earmark'
    },
  },
}
</script>

<template>
  <div class="ec-documents-list">
    <a
      v-for="(doc, index) in documents"
      :key="doc.id || index"
      :href="doc.url"
      target="_blank"
      class="ec-document-card"
    >
      <i class="bi" :class="iconClass(doc.name)" />
      <span class="ec-document-card__name">{{ doc.name }}</span>
      <i class="bi bi-download ec-document-card__dl" />
    </a>
  </div>
</template>

<style scoped>
.ec-documents-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.ec-document-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--ec-border-color, #dee2e6);
  border-radius: var(--ec-border-radius, 0.375rem);
  background: var(--ec-bg, #fff);
  text-decoration: none;
  color: inherit;
  font-size: 0.875rem;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ec-document-card:hover {
  border-color: var(--ec-primary, #0d6efd);
  box-shadow: 0 0 0 1px var(--ec-primary, #0d6efd);
}

.ec-document-card .bi-file-pdf {
  color: #dc3545;
}

.ec-document-card .bi-file-word {
  color: #0d6efd;
}

.ec-document-card__name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ec-document-card__dl {
  margin-left: auto;
  opacity: 0.5;
}

.ec-document-card:hover .ec-document-card__dl {
  opacity: 1;
}
</style>
